import { createApi } from '@reduxjs/toolkit/query/react';

import {
  NeuralNetworkLogsEndpoints as Endpoints,
  type GetNeuralNetworkLogsRequest,
  type GetNeuralNetworkLogsResponse,
} from '@app/api/NeuralNetworkLogs/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';

const NEURAL_NETWORK_LOGS = 'NeuralNetworkLogs';

export const neuralNetworkLogsApi = createApi({
  reducerPath: 'neuralNetworkLogsApi',
  baseQuery: createApiBaseQuery(NEURAL_NETWORK_LOGS),
  endpoints: ({ query }) => ({
    GetNeuralNetworkLogs: query<
      GetNeuralNetworkLogsResponse,
      GetNeuralNetworkLogsRequest
    >({
      query: (params) => ({
        url: Endpoints.GetNeuralNetworkLogs,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useGetNeuralNetworkLogsQuery,
  useLazyGetNeuralNetworkLogsQuery,
} = neuralNetworkLogsApi;
